import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { styled, makeStyles } from '../styles';
function filterProps(props) {
    const { margin, ...rest } = props;
    return rest;
}
const StyledInputContainer = styled(props => React.createElement("div", { ...filterProps(props) }))(({ theme: { palette, spacing }, margin }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: spacing(4),
    margin: margin ? spacing(1.5, 0) : 'none',
    appearance: 'none',
    background: palette.background.default,
    borderRadius: spacing(0.5),
    border: `1px solid ${palette.grey.lightTint}`,
    color: palette.grey.offBlack,
    '&:focus-within': {
        border: `1px solid ${palette.secondary.main}`,
    },
}));
const StyledInput = styled('input')(({ theme: { palette, spacing } }) => ({
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    padding: spacing(0.5, 1),
    appearance: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: spacing(0.5),
    color: palette.text.main,
    '&:focus': {
        outline: 'none',
    },
}));
const useStyles = makeStyles(({ spacing, palette }) => ({
    endIcon: {
        color: palette.text.secondary,
        marginRight: spacing(),
    },
    startIcon: {
        padding: spacing(0.25),
        marginLeft: spacing(),
    },
}));
function TypedInput({ InputProps, margin, placeholder, startIcon, endIcon, onChange, onKeyPress, value, className, id, name, type, defaultValue, required, inputClassName, autoFocus, }) {
    const classes = useStyles();
    let EndIcon = null;
    let StartIcon = null;
    if (endIcon) {
        EndIcon = cloneElement(endIcon, {
            className: classNames(endIcon?.props.className, classes.endIcon),
        });
    }
    if (startIcon) {
        StartIcon = cloneElement(startIcon, {
            className: classNames(endIcon?.props.className, classes.startIcon),
        });
    }
    return (React.createElement(StyledInputContainer, { margin: margin, className: className },
        StartIcon,
        React.createElement(StyledInput, { autoFocus: true, className: inputClassName, id: id, name: name, type: type, defaultValue: defaultValue, required: required, onChange: onChange, onKeyPress: onKeyPress, value: value, placeholder: placeholder, ...InputProps }),
        EndIcon));
}
export default TypedInput;
//# sourceMappingURL=TypedInput.js.map